import React, {useState} from 'react'
import { connect } from "react-redux";
import {Button, Col, FormGroup, Input, InputGroup, Label, Row} from "reactstrap";


// components
import { ButtonClean } from "../../../components/buttons/buttonsActions";

// actions
import { setFilter, setTableParams } from "../../../redux/actions/generalActions/listActions";

// labels
import {LB_RESERVATION_NUMBER} from "../../../components/i18n/i18n";


const WishlistFilter = props => {
    const { filter } = props.listState
    const udn = JSON.parse(localStorage.getItem('selectedUdn')) || null

    const [reservationNumber, setReservationNumber] = useState('')
    const [resetValues, setResetValues] = useState( false )

    const onSubmit = () => {
        let filterData = { ...filter }

        if(reservationNumber.length > 0)
            filterData = { ...filterData, reservationNumber }

        props.setFilter(filterData);
    }

    const cleanFields = () => {
        setReservationNumber('')
        setResetValues(!resetValues)

        props.setTableParams()
        props.setFilter({
            udn:{ id : udn?.id },
            searchType : props.type
        } );
    }

    return <Row className={'mb-1em'}>
        <Col sm={2}>
            <FormGroup>
                <Label>{LB_RESERVATION_NUMBER}</Label>
                <InputGroup>
                    <Input
                        type="text"
                        name="reservationNumber"
                        value={ reservationNumber }
                        onChange={ e => setReservationNumber( e?.target?.value ) }
                    />
                    <Button
                        className={'wl-btn-search'}
                        onClick={ onSubmit }
                        outline
                    >
                        <i className={'fa fa-search'} aria-hidden="true" />
                    </Button>
                    <Button
                        className={'wl-btn-search'}
                        onClick={ cleanFields }
                        outline
                    >
                        <i className={'fa fa-times'} aria-hidden="true" />
                    </Button>
                </InputGroup>
            </FormGroup>
        </Col>
    </Row>
}

const mapStateToProps = state => ({
    listState: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams
})

export default connect(mapStateToProps, mapActionsToProps)(WishlistFilter)